'use client';
import { createLogger } from '@svenskaspelab/nova-core/log';
import { useEffect } from 'react';
const logger = createLogger('poolbetting.sportinfo.swehockey');
/**
 * SweHockeyInitializer is responsible for bootstrapping the Impleo SweHockey widget system.
 * Boots Impleo with the provided `uiToken`.
 *
 * Contract:
 * - The embedding app (e.g. Powerplay) must load the external script(swe-hockey-min.js) before this provider mounts.
 *
 * @param root0 component props
 * @param root0.children html to render within the provider
 * @param root0.uiToken the UI token to use when booting Impleo
 * @returns The children wrapped by the SweHockeyInitializer
 */
export function SweHockeyInitializer({ children, uiToken }) {
    useEffect(() => {
        const boot = () => {
            if (!window.Impleo) {
                logger.error('Impleo was not loaded before boot');
                return;
            }
            window.Impleo.boot({
                ui: uiToken,
                url: 'https://widgets.swehockey.se',
                connectWebSockets: true,
            });
        };
        window.addEventListener('impleo-script-loaded', boot);
        if (window.Impleo) {
            boot();
        }
        return () => {
            window.removeEventListener('impleo-script-loaded', boot);
        };
    }, [uiToken]);
    return children;
}
//# sourceMappingURL=SwehockeyInitializer.js.map